import { FC } from 'react';
import { Button, Modal, Typography, theme } from 'antd';

import FlexBox from '../../../atoms/FlexBox';
import FlexCol from '../../../atoms/FlexCol';

const { Text } = Typography;

interface DeleteSavedViewModalProps {
  open: boolean;
  viewName: string;
  onConfirmDelete: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DeleteSavedViewModal: FC<DeleteSavedViewModalProps> = ({
  open,
  viewName,
  onConfirmDelete,
  onCancel,
  loading = false,
}) => {
  const { token } = theme.useToken();

  return (
    <Modal title="Delete Saved View" open={open} onCancel={onCancel} footer={null}>
      <FlexCol noGap stretch style={{ width: '100%' }}>
        <FlexCol noGap stretch style={{ width: '100%' }}>
          <Text>
            Delete <Text strong>"{viewName}"</Text>? This cannot be undone.
          </Text>
        </FlexCol>
        <FlexBox noGrow style={{ width: '100%', marginTop: token.marginLG }}>
          <Button
            aria-label="Cancel delete saved view"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            aria-label="Delete saved view"
            type="primary"
            onClick={onConfirmDelete}
            loading={loading}
            disabled={loading}
          >
            Delete
          </Button>
        </FlexBox>
      </FlexCol>
    </Modal>
  );
};

export default DeleteSavedViewModal;

